import type { AdapterInfoDTO, CreateSourceInput, RunSourceResult, SourceDTO, UpdateSourceInput } from "../../api/contract";
import { apiDelete, apiGet, apiPatch, apiPost, buildQuery } from "./http";

export function listSources(): Promise<SourceDTO[]> {
  return apiGet<SourceDTO[]>("/api/sources");
}

export function getSource(id: number): Promise<SourceDTO> {
  return apiGet<SourceDTO>(`/api/sources/${id}`);
}

export function createSource(input: CreateSourceInput): Promise<SourceDTO> {
  return apiPost<SourceDTO>("/api/sources", input);
}

export function updateSource(id: number, patch: UpdateSourceInput): Promise<SourceDTO> {
  return apiPatch<SourceDTO>(`/api/sources/${id}`, patch);
}

export function deleteSourceApi(id: number): Promise<void> {
  return apiDelete(`/api/sources/${id}`);
}

export function runSource(id: number, opts: { limit?: number; dryRun?: boolean } = {}): Promise<RunSourceResult> {
  const qs = buildQuery({ limit: opts.limit, dryRun: opts.dryRun ? 1 : undefined });
  return apiPost<RunSourceResult>(`/api/sources/${id}/run${qs}`);
}

export function seedDefaultSources(): Promise<{ added: number }> {
  return apiPost<{ added: number }>("/api/sources/seed");
}

export function listAdapters(): Promise<AdapterInfoDTO[]> {
  return apiGet<AdapterInfoDTO[]>("/api/sources/adapters");
}
